export default "__VITE_ASSET__Xng_ifQi__"